import React from "react";
import PropTypes from "prop-types";
import { Chip, Divider, MenuItem, Stack, Typography } from "@mui/material";
import { GlassPanel, ModernTextField } from "../styledComponents";

const DATE_FIELD_WIDTH = { xs: "100%", md: "50%" };
const VALUE_FIELD_WIDTH = { xs: "66.6667%", md: "41.6667%" };
const UNIT_FIELD_WIDTH = { xs: "33.3333%", md: "25%" };

const BiometriaHematica = ({ formValues, onChange }) => {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    onChange(name, value);
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <GlassPanel>
      <Stack spacing={3}>
        <Stack spacing={1}>
          <Typography variant="overline" sx={{ letterSpacing: 3 }}>
            Análisis clínico
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: "primary.main" }}
          >
            Biometría hemática
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Mantén visibles los valores que narran la salud hematológica del
            paciente para correlacionarlos con el resto del expediente.
          </Typography>
          <Stack direction="row" spacing={1}>
            {["Fecha", "Valores", "Seguimiento"].map((tag) => (
              <Chip key={tag} label={tag} size="small" variant="outlined" />
            ))}
          </Stack>
        </Stack>

        <Divider />

        <Stack spacing={3}>
          <ModernTextField
            label="Fecha de la biometría"
            name="biometriaHematicaFecha"
            type="date"
            value={formValues.biometriaHematicaFecha || ""}
            onChange={handleInputChange}
            fullWidth
            inputProps={{ max: today }}
            InputLabelProps={{ shrink: true }}
            helperText="Última fecha registrada del estudio"
            sx={{ width: DATE_FIELD_WIDTH }}
          />

          <Stack spacing={1.5}>
            <Typography variant="subtitle2" color="text.secondary">
              Hemoglobina
            </Typography>
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={2}
              sx={{ flexWrap: "wrap" }}
            >
              <ModernTextField
                label="Valor"
                name="hemoglobina"
                type="number"
                value={formValues.hemoglobina || ""}
                onChange={handleInputChange}
                fullWidth
                sx={{ width: VALUE_FIELD_WIDTH }}
              />
              <ModernTextField
                select
                label="Unidad"
                name="hemoglobinaUnidad"
                value={formValues.hemoglobinaUnidad || "g/dL"}
                onChange={handleInputChange}
                fullWidth
                sx={{ width: UNIT_FIELD_WIDTH }}
              >
                <MenuItem value="g/dL">g/dL</MenuItem>
              </ModernTextField>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </GlassPanel>
  );
};

BiometriaHematica.propTypes = {
  formValues: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default BiometriaHematica;
